import { themePropDefs } from "@radix-ui/themes/components/theme.props";
import { RefObject } from "react";

export type ThemeContextValue = {
  appearance: any;
  accentColor: any;
  grayColor: any;
  panelBackground: any;
  radius: any;
  scaling: any;
  portalContainer: undefined | RefObject<HTMLElement>;
};

export const themeDefaults: ThemeContextValue = {
  appearance: themePropDefs.appearance.default,
  accentColor: themePropDefs.accentColor.default,
  grayColor: themePropDefs.grayColor.default,
  panelBackground: themePropDefs.panelBackground.default,
  radius: themePropDefs.radius.default,
  scaling: themePropDefs.scaling.default,
  portalContainer: undefined,
};

export function Theme(props) {
  const { children, as = "div" } = props;
  const Component = as;
  return (
    <Component
      className={"radix-themes light"}
      data-radius={themeDefaults.radius}
      data-scaling={themeDefaults.scaling}
      data-accent-color={themeDefaults.accentColor}
      data-gray-color={themeDefaults.grayColor}
      data-has-background={"false"}
      data-panel-background={themeDefaults.panelBackground}
      {...props}
    >
      {children}
    </Component>
  );
}
